import { render, staticRenderFns } from "./vbConnect.vue?vue&type=template&id=95a8e8cc&scoped=true&lang=pug&"
import script from "./vbConnect.vue?vue&type=script&lang=js&"
export * from "./vbConnect.vue?vue&type=script&lang=js&"
import style0 from "./vbConnect.vue?vue&type=style&index=0&id=95a8e8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a8e8cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95a8e8cc')) {
      api.createRecord('95a8e8cc', component.options)
    } else {
      api.reload('95a8e8cc', component.options)
    }
    module.hot.accept("./vbConnect.vue?vue&type=template&id=95a8e8cc&scoped=true&lang=pug&", function () {
      api.rerender('95a8e8cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/dialog/vbConnect.vue"
export default component.exports